import React, { useEffect, useState } from "react";
import { observer } from 'mobx-react';
import { Box, Typography, Paper, IconButton, Tooltip, Collapse, Link, Skeleton, Button } from "@mui/material";
import styles from './contacts.module.scss';
import { ReactComponent as ArrowIcon } from '../../icons/arrow.svg';
import { ReactComponent as StarIcon } from '../../icons/star.svg';
import { CallCalling, MessageText1, Sms, Location, Tag2, Edit2, Global } from "iconsax-react";
import Slider from '../shared/Slider';
import { getNameFromProfileOptions, getPhoneNumberWihKey } from "../../utils/profile-utils";
import ContactCard from "./contact-card";
import LabelModal from "./label-modal";
import TagsModal from "./tags-modal";
import CardsSlider from "./cards-slider";
import ViewImgModal from "../../my-data/category/view-img-modal";

const Contact = observer(({ history, contact, uiStore, settings }) => {
    const [card, setCard] = useState({});
    const [label, setLabel] = useState({});
    const [name, setName] = useState('');
    const [location] = useState({ lat: 10, lng: 10, zoom: 1 });
    const [expanded, setExpanded] = useState(false);
    const [showLabelModal, setShowLabelModal] = useState(false);
    const { getLabelAndDefaultCard } = uiStore;
    const [update, setUpdate] = useState(false);
    const [lang, setLang] = useState('');
    const [favorite, setFavorite] = useState(false);
    const [tags, setTags] = useState([]);
    const [showTagsModal, setShowTagsModal] = useState(false);
    const [showImgModal, setShowImgModal] = useState(false);
    const SliderProps = {
        zoomFactor: 0,
        slideMargin: 5,
        maxVisibleSlides: 3,
        pageTransition: 500
    };

    const toggleExpand = () => {
        setExpanded(val => !val);
    }

    const toggleFavirote = () => {
        uiStore.toggleFavirote(!favorite, card?._id);
        setFavorite(val => !val);
    }

    useEffect(() => {
        const fetchData = async () => {
            const data = await getLabelAndDefaultCard(contact.length ? contact[0]?._id : contact._id);

            setLabel(data.label);
            let { card } = data;

            if (contact[0]?.allowAlias)
                card = contact.find(i => i._id === data.card?._id) || contact[0];
            else
                card = contact[0];


            if (data.label?.name) {
                setName(data.label?.name);
            } else {
                let lng = '';
                if (card?.langs?.includes(settings.firstLanguage))
                    lng = settings.firstLanguage
                else if (card?.langs?.includes(settings.secondLanguage))
                    lng = settings.secondLanguage
                else
                    lng = card?.langs[0]

                setName(getNameFromProfileOptions(card, settings.nameFormat, lng));
                setLang(lng);
            }
            setFavorite(card?.favorite);
            setCard(card);
            setTags(card?.tags);
        }

        fetchData();
    }, [contact, getLabelAndDefaultCard, settings, update])

    return (
        <>
            <Paper variant="round" sx={expanded ? { borderRadius: '16px 16px 0px 0px', mt: 2, overflow: 'hidden' } : { mb: 0, mt: 2, overflow: 'hidden' }}>
                <Box className={styles.contact}>
                    <Box className={styles.contactName}>
                        {card?.image ?
                            <Button onClick={() => setShowImgModal(true)}><img src={!!label?.img ? label.img : card?.image} alt='pic' /></Button>
                            :
                            <Skeleton variant='circular' height={50} width={50} />
                        }
                        <ViewImgModal img={!!label?.img ? label.img : card?.image} show={showImgModal} setShow={setShowImgModal} />
                        <Box sx={{ ml: 2, minHeight: '60px' }} >
                            <Link href={'/card/' + card?._id + '/all'} sx={{ textDecorationColor: 'rgba(29, 23, 97, 0)' }}>
                                <Typography fontWeight={600} fontSize='16px'>{name}</Typography>
                            </Link>
                            {expanded ?
                                <Box sx={{
                                    display: { md: 'none', sm: 'flex', xs: 'flex', width: '100%' },
                                }}>
                                    <IconButton onClick={() => setShowLabelModal(true)}>
                                        <Edit2
                                            size="20"
                                            variant="Bulk"
                                        />
                                    </IconButton>
                                    <IconButton onClick={() => setShowTagsModal(true)}>
                                        {tags?.length > 0 ?
                                            <Tag2
                                                size="22"
                                                variant="Bulk"
                                                color="#02B28E"
                                            />
                                            :
                                            <Tag2
                                                size="22"
                                                variant="Bulk"
                                            />
                                        }
                                    </IconButton>
                                    <IconButton onClick={toggleFavirote}>
                                        {favorite ?
                                            <StarIcon
                                                width="18"
                                                height="18"
                                                fill="#FFB300"
                                            />
                                            :
                                            <StarIcon
                                                width="18"
                                                height="18"
                                                fill="#888"
                                            />
                                        }
                                    </IconButton>
                                </Box>
                                :
                                <>
                                    {card?.Number &&
                                        <Tooltip title="Call">
                                            <IconButton href={"tel:" + getPhoneNumberWihKey(card?.Number)}
                                            >
                                                <CallCalling
                                                    size="20"
                                                    variant="Bulk"
                                                />
                                            </IconButton>
                                        </Tooltip>
                                    }
                                    {card?.Number &&
                                        <Tooltip title="Text">
                                            <IconButton href={"sms:" + getPhoneNumberWihKey(card?.Number)}
                                            >
                                                <MessageText1
                                                    size="20"
                                                    variant="Bulk"
                                                />
                                            </IconButton>
                                        </Tooltip>
                                    }
                                    {card?.Email &&
                                        <Tooltip title="Email">
                                            <IconButton href={"mailto:" + card.Email.infoValue} >
                                                <Sms
                                                    size="20"
                                                    variant="Bulk"
                                                />
                                            </IconButton>
                                        </Tooltip>
                                    }
                                    {card?.Location &&
                                        <Tooltip title="Location">
                                            <IconButton
                                                href={`https://www.google.com/maps/search/?api=1&query=${location.lat},${location.lng}`} target="_blank" rel="noreferrer"
                                            >
                                                <Location
                                                    size="20"
                                                    variant="Bulk"
                                                />
                                            </IconButton>
                                        </Tooltip>
                                    }
                                    {card?.Website &&
                                        <Tooltip title="Website">
                                            <IconButton
                                                href={card.Website.infoValue} target="_blank" rel='noopener noreferrer'
                                            >
                                                <Global
                                                    size="20"
                                                    variant="Bulk"
                                                />
                                            </IconButton>
                                        </Tooltip>
                                    }
                                </>
                            }
                        </Box>

                    </Box>
                    <Box>
                        <Box sx={{ display: { md: 'inline-flex', sm: 'none', xs: 'none' } }}>
                            <IconButton onClick={() => setShowLabelModal(true)}>
                                <Edit2
                                    size="22"
                                    variant="Bulk"
                                />
                            </IconButton>
                            <IconButton onClick={() => setShowTagsModal(true)}>
                                {tags?.length > 0 ?
                                    <Tag2
                                        size="24"
                                        variant="Bulk"
                                        color="#02B28E"
                                    />
                                    :
                                    <Tag2
                                        size="24"
                                        variant="Bulk"
                                    />
                                }
                            </IconButton>
                            <IconButton onClick={toggleFavirote}>
                                {favorite ?
                                    <StarIcon
                                        width="20"
                                        height="20"
                                        fill="#FFB300"
                                    />
                                    :
                                    <StarIcon
                                        width="20"
                                        height="20"
                                        fill="#888"
                                    />
                                }
                            </IconButton>
                        </Box>
                        <IconButton onClick={toggleExpand} sx={{ mt: -1 }}>
                            <ArrowIcon
                                width="14"
                                height="14"
                                style={expanded ? { transform: 'rotate(180deg)' } : {}}
                            />
                        </IconButton>
                    </Box>
                </Box>
            </Paper>
            <Collapse in={expanded} timeout={800}>
                <Paper variant="round" sx={{ borderRadius: '0px 0px 16px 16px', borderTop: '1px solid #EEF2F8', mb: 2, overflow: 'hidden' }}>
                    <Box sx={{ m: ' 16px 0' }}>
                        {contact?.length && contact?.length > 1 ?
                            <>
                                <Box sx={{ display: { lg: 'block', md: 'block', sm: 'block', xs: 'none' } }}>
                                    <Slider {...SliderProps}>
                                        {
                                            contact.map(item => (
                                                <ContactCard
                                                    key={item._id}
                                                    card={item}
                                                    settings={settings}
                                                    defaultCard={card?._id}
                                                    update={() => setUpdate(val => !val)}
                                                    uiStore={uiStore}
                                                    contacts
                                                />
                                            ))
                                        }
                                    </Slider>
                                </Box>
                                <Box sx={{ display: { lg: 'none', md: 'none', sm: 'none', xs: 'block' } }}>
                                    <CardsSlider
                                        settings={settings}
                                        defaultCard={card?._id}
                                        update={() => setUpdate(val => !val)}
                                        uiStore={uiStore}
                                        contact={contact}
                                    />
                                </Box>
                            </>
                            :
                            <Box sx={{ margin: '0 auto', width: 'fit-content' }}>
                                <ContactCard
                                    card={contact[0]}
                                    settings={settings}
                                    defaultCard={card?._id}
                                    update={() => setUpdate(val => !val)}
                                    uiStore={uiStore}
                                    contacts
                                />
                            </Box>
                        }
                    </Box>
                </Paper>
            </Collapse>
            {
                card &&
                <LabelModal
                    uiStore={uiStore}
                    setShow={setShowLabelModal}
                    show={showLabelModal}
                    card={card}
                    label={label}
                    cardName={getNameFromProfileOptions(card, settings.nameFormat, lang)}
                    updateModal={() => setUpdate(val => !val)}
                />
            }
            {
                card?.tags &&
                <TagsModal
                    uiStore={uiStore}
                    setShow={setShowTagsModal}
                    show={showTagsModal}
                    card={card}
                    setTags={setTags}
                    tags={card?.tags}
                />
            }
        </>
    );
});

export default Contact;